import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserModel } from 'src/app/models/user';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-add-email',
  templateUrl: './add-email.component.html',
  styleUrls: ['./add-email.component.css']
})
export class AddEmailComponent implements OnInit {
  form: FormGroup;
  processing: boolean = false;
  currentUser: UserModel = {} as UserModel;
  constructor(
    private fb: FormBuilder,
    public user: UserService,
    public self: MatDialogRef<AddEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public reference: any

  ) {  }

  ngOnInit(): void {
    this.currentUser = this.user.getUser();
    
    this.form = this.fb.group({
      email: ["", [Validators.required, Validators.email]]
    });

    // this.form.patchValue({
    //   email: this.currentUser.email,
    // })
  }
  onSubmit(): void {
    const value = this.form.value;
    if (this.form.invalid) return this.form.markAllAsTouched();;
    if (value.email == this.currentUser.email){
      console.log('YY');
      
    }
    this.processing = true;
    this.user.updateProfile(this.form.value)
    .then(() => {
      this.self.close(true);
    })
    .catch(() => {
      this.processing = false;
      this.form.setErrors({
        unknow: true
      });
    })
  }
  // get firstName(): FormControl {
  //   return this.form.get('first_name') as FormControl;
  // }
  // get lastName(): FormControl {
  //   return this.form.get('last_name') as FormControl;
  // }
  // get gender(): FormControl {
  //   return this.form.get('gender') as FormControl;
  // }
}
